import React, { useState, useEffect } from "react";
import { categoriesApi } from "../services/api";
import "./CategorySelect.css";

const DEFAULT_CATEGORIES = ["Food", "Dairy", "Cleaning", "Personal Care", "Beverages"];

export default function CategorySelect({ value, onChange }) {
  const [customCategories, setCustomCategories] = useState([]);
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customValue, setCustomValue] = useState("");
  const [saveForFuture, setSaveForFuture] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    categoriesApi.getAll()
      .then(setCustomCategories)
      .catch(() => {});
  }, []);

  const allCategories = [
    ...DEFAULT_CATEGORIES,
    ...customCategories.map((c) => c.name).filter((n) => !DEFAULT_CATEGORIES.includes(n)),
  ];

  const handleSelectChange = (e) => {
    const val = e.target.value;
    if (val === "__other__") {
      setShowCustomInput(true);
      setCustomValue("");
      onChange("");
    } else {
      setShowCustomInput(false);
      onChange(val);
    }
  };

  const handleCustomConfirm = async () => {
    if (!customValue.trim()) return;
    const name = customValue.trim();

    if (saveForFuture) {
      setLoading(true);
      try {
        const saved = await categoriesApi.create(name);
        setCustomCategories((prev) => {
          const exists = prev.find((c) => c.name.toLowerCase() === saved.name.toLowerCase());
          return exists ? prev : [...prev, saved];
        });
      } catch {}
      finally { setLoading(false); }
    }

    onChange(name);
    setShowCustomInput(false);
    setCustomValue("");
  };

  const handleCustomKeyDown = (e) => {
    if (e.key === "Enter") handleCustomConfirm();
    if (e.key === "Escape") { setShowCustomInput(false); onChange(""); }
  };

  // Determine current select value
  const selectValue = showCustomInput
    ? "__other__"
    : value && !allCategories.includes(value)
    ? value  // custom value already set
    : value || "";

  return (
    <div className="cat-select-wrap">
      <select
        className="cat-select"
        value={selectValue}
        onChange={handleSelectChange}
      >
        <option value="">None</option>
        {allCategories.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
        {value && !allCategories.includes(value) && (
          <option value={value}>{value}</option>
        )}
        <option value="__other__">➕ Add new category…</option>
      </select>

      {showCustomInput && (
        <div className="cat-custom-wrap">
          <input
            autoFocus
            placeholder="Type category name…"
            value={customValue}
            onChange={(e) => setCustomValue(e.target.value)}
            onKeyDown={handleCustomKeyDown}
            className="cat-custom-input"
          />
          <label className="cat-save-label">
            <input
              type="checkbox"
              checked={saveForFuture}
              onChange={(e) => setSaveForFuture(e.target.checked)}
              className="cat-checkbox"
            />
            Save for future use
          </label>
          <div className="cat-custom-actions">
            <button className="cat-cancel-btn" onClick={() => { setShowCustomInput(false); onChange(""); }}>
              Cancel
            </button>
            <button className="cat-confirm-btn" onClick={handleCustomConfirm} disabled={!customValue.trim() || loading}>
              {loading ? "Saving…" : "Confirm"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
